import Cargos from '@/models/Cargos'

export default [
  {
    path: '/administrativo/estoque',
    name: 'rota-estoque',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Estoque',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Estoque',
      icon: 'layer-group',
    },
    component: () => import(/* webpackChunkName: "estoque" */ '../views/estoque/Estoque.vue'),
  },
]
